import { translate } from '@/domains/core/localization/translate';
export const translations = translate({
  "title": "Sort by"
});